import React from "react";

import { withNamespaces } from 'react-i18next';

const AcSaude = ({ t }) => {
  return (
    <>
      <div className="accordion" id="accordionExample2">
        {/* 1 - UNIDADES DE SAÚDE */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse1"
              aria-expanded="true"
              aria-controls="collapse2"
            >
              {t('moduleCidadeAveiro:S2.ST1.A.A1.T')}
            </button>
          </h2>
          <div
            id="collapse1"
            className="accordion-collapse collapse"
            aria-labelledby="heading1"
            data-bs-parent="#accordionExample2"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <ul className="bulletpoint">
                  <li>
                    <p className="p_next"
                      dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST1.A.A1.LI1') }}>
                    </p>
                  </li>
                  <li>
                    <p className="p_next"
                      dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST1.A.A1.LI2') }}>
                    </p>
                  </li>
                  <li>
                    <p className="p_next"
                      dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST1.A.A1.LI3') }}>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - PAGAMENTOS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading2">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse2"
              aria-expanded="false"
              aria-controls="collapse2"
            >
              {t('moduleCidadeAveiro:S2.ST1.A.A2.T')}
            </button>
          </h2>
          <div
            id="collapse2"
            className="accordion-collapse collapse"
            aria-labelledby="heading2"
            data-bs-parent="#accordionExample2"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <ul className="bulletpoint">
                  <li>
                    <p className="p_next"
                      dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST1.A.A2.LI1') }}>
                    </p>
                  </li>
                  <li>
                    <p className="p_next">
                      {t('moduleCidadeAveiro:S2.ST1.A.A2.LI2')}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 3 - VACINAS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading3">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3"
              aria-expanded="false"
              aria-controls="collapse3"
            >
              {t('moduleCidadeAveiro:S2.ST1.A.A3.T')}
            </button>
          </h2>
          <div
            id="collapse3"
            className="accordion-collapse collapse"
            aria-labelledby="heading3"
            data-bs-parent="#accordionExample2"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <ul className="bulletpoint">
                  <li>
                    <p className="p_next"
                      dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST1.A.A3.LI1') }}>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 4 - FARMÁCIAS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading4">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse4"
              aria-expanded="false"
              aria-controls="collapse4"
            >
              {t('moduleCidadeAveiro:S2.ST1.A.A4.T')}
            </button>
          </h2>
          <div
            id="collapse4"
            className="accordion-collapse collapse"
            aria-labelledby="heading4"
            data-bs-parent="#accordionExample2"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <ul className="bulletpoint">
                  <li>
                    <p className="p_next"
                      dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST1.A.A4.LI1') }}>
                    </p>
                  </li>
                  <li>
                    <p className="p_next"
                      dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST1.A.A4.LI2') }}>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(AcSaude);
